import Model    from "./Model";

export default class Event extends Model
{
    constructor( options = {} )
    {
        super(null);

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id     = options.id    || null;
        this.name   = options.name  || null;
        this.img    = options.img   || null;
    }

    toJson ()
    {
        return {
            id      : this.id,
            name    : this.name,
            img     : this.img,
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/models/Industry.js